import React from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { fontFamilyMonserrat, WHITE } from '../../../theme'
import styles from '../../../styles'
import { FormattedMessage, useIntl } from 'react-intl'
import thousandsSeparator from '../../../utils/formatter/thousandsSeparator'
import { dateAvecPoints } from '../../../utils/formatter/formatDate'
import { OffreModel } from '../types/OffreModel'
import { lotTypesEnum } from '../../../enums/lot/lotTypesEnum'
import BoutonSelectionner from './BoutonSelectionner'

const useStyles = makeStyles()(
	(theme) => ({
		informationsTarifairesContainer: {
			height: 100,
			minHeight: 100,
			background: WHITE,
			borderRadius: '30px 30px 0 0',
			paddingLeft: 30,
			paddingRight: 16,
			boxShadow: '0px -10px 20px #12294131'
		},
		disponibilite: {
			...styles(theme).text9,
			marginTop: 10
		},
		tarification: {
			...styles(theme).title6,
			fontSize: 23,
			display: 'flex',
			flexDirection: 'column',

			'& span': {
				fontSize: 10,
				fontWeight: 500,
				fontFamily: fontFamilyMonserrat
			}
		},
		boutonTarification: {
			borderRadius: 25,
			height: 'fit-content'
		},
		referenceStyle: {
			fontSize: 12,
			fontFamily: fontFamilyMonserrat,
			fontWeight: 500,
			marginTop: 10
		}
	})
)

interface AcceptingProps {
	offre: OffreModel
}

type InformationsTarifairesProps = AcceptingProps

const InformationsTarifaires: React.FC<InformationsTarifairesProps> = (
	{
		offre
	}
) => {
	const { classes } = useStyles()
	const intl = useIntl()

	return (
		<Grid container item xs={12} justifyContent="space-between" alignItems="center" className={classes.informationsTarifairesContainer}>
			<Grid container item xs direction="column">
				<span className={classes.referenceStyle}>
					<FormattedMessage
						id="offre.caracteristiques.reference"
						defaultMessage="Référence : {ref}"
						description="Référence de l'offre"
						values={{
							ref: offre.idMgcCrm
						}}
					/>
				</span>

				<span className={classes.disponibilite}>
					{
						offre.type === lotTypesEnum.apartment ? (
							new Date(offre.dateDisponibilite) < new Date() ? (
								<FormattedMessage
									id="offre.caracteristiques.available"
									defaultMessage="Disponible"
									description="Information sur la date de disponibilité"
								/>
							) : (
								<FormattedMessage
									id="offre.caracteristiques.dateDisponibilite"
									defaultMessage="Disponible le {date}"
									description="Information sur la date de disponibilité"
									values={{
										date: dateAvecPoints(new Date(offre.dateDisponibilite), intl.locale)
									}}
								/>
							)
						) : (
							<FormattedMessage
								id="offre.caracteristiques.disponibleMaintenant"
								defaultMessage="Disponible"
								description="Information sur la date de disponibilité"
							/>
						)
					}
				</span>

				<span className={classes.tarification}>
					<FormattedMessage
						id="offre.menuAncre.tarificationMobil"
						defaultMessage="{loyer} € <span>CC / mois</span>"
						description="Montant du loyer en €"
						values={{
							loyer: thousandsSeparator(offre.tarification.prixMensuel, false),
							span: (chunk) => <span>{chunk}</span>
						}}
					/>
				</span>
			</Grid>

			<Grid container item xs={5}>
				<BoutonSelectionner offre={offre} />
			</Grid>
		</Grid>
	)
}

export default InformationsTarifaires